import { motion } from "framer-motion";

export default function MissionVision() {
  const values = [
    {
      title: "Innovation",
      description: "Continuously pushing boundaries with cutting-edge technology solutions",
      icon: "ri-lightbulb-flash-line",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      title: "Integrity",
      description: "Building trust through transparency and ethical business practices",
      icon: "ri-shield-check-line",
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
    {
      title: "Connectivity",
      description: "Bridging gaps and creating seamless communication channels",
      icon: "ri-links-line",
      color: "text-orange-600",
      bgColor: "bg-orange-50",
    },
    {
      title: "Empowerment",
      description: "Enabling individuals and businesses to achieve their full potential",
      icon: "ri-hand-heart-line",
      color: "text-blue-600",
      bgColor: "bg-blue-50",
    },
    {
      title: "Excellence",
      description: "Delivering superior quality in every service and interaction",
      icon: "ri-star-line",
      color: "text-green-600",
      bgColor: "bg-green-50",
    },
  ];

  return (
    <section id="mission" className="py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">

        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Mission, Vision &{" "}
            <span className="text-blue-600">Core Values</span>
          </h2>
        </motion.div>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-12 mb-20">
          
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, x: -60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="bg-gradient-to-br from-blue-600 to-blue-700 p-10 rounded-2xl shadow-xl text-white"
          >
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-compass-3-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">Our Mission</h3>
            <p className="text-base leading-relaxed text-blue-50">
              Empowering people and businesses through innovative technology and
              digital solutions that drive growth, enhance connectivity, and
              create lasting opportunities across Nigeria and Africa.
            </p>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, x: 60 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            className="bg-gradient-to-br from-orange-500 to-orange-600 p-10 rounded-2xl shadow-xl text-white"
          >
            <div className="w-16 h-16 bg-white/20 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-line text-4xl text-white"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">Our Vision</h3>
            <p className="text-base leading-relaxed text-orange-50">
              Building Africa's most trusted tech-driven ecosystem that
              transforms lives, connects communities, and powers the digital
              economy of tomorrow.
            </p>
          </motion.div>
        </div>

        {/* Core Values */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.15 } },
          }}
        >
          <h3 className="text-3xl font-bold text-gray-900 mb-10 text-center">
            Core Values
          </h3>

          <div className="grid sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {values.map((value, index) => (
              <motion.div
                key={index}
                variants={{
                  hidden: { opacity: 0, y: 30 },
                  visible: { opacity: 1, y: 0 },
                }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                whileHover={{ y: -6 }}
                className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all text-center cursor-pointer"
              >
                <div className={`w-16 h-16 ${value.bgColor} rounded-xl flex items-center justify-center mb-4 mx-auto`}>
                  <i className={`${value.icon} text-3xl ${value.color}`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3">
                  {value.title}
                </h4>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </motion.div>
            ))}
          </div>
        </motion.div>

      </div>
    </section>
  );
}
